const handlers = {
  onSetPreferences: props => (key, e) => {
    const preferences = {
      ...props.preferences,
      [key]: (key === 'tippedEmployees') ? e.target.checked : e.target.value
    }
    props.setPreferences(preferences)
  }
}

export default handlers
